module.exports = __webpack_public_path__ + "img/social-icon-twitter.1f030852.svg";